import React from 'react';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import CheckCircleRoundedIcon from '@material-ui/icons/CheckCircleRounded';
import RemoveRoundedIcon from '@material-ui/icons/RemoveRounded';
import VerifiedUserOutlinedIcon from '@material-ui/icons/VerifiedUserOutlined';
import DataTable from '../../components/DataTable/DataTable';
import { shortData } from '../../helpers';
import SectionCard from './SectionCard';

const ACTIONS = ['view', 'add', 'edit', 'delete'];

const columns = [
  { id: 'name', label: 'Feature' },
  ...ACTIONS.map((action) => ({
    id: action, label: action[0].toUpperCase() + action.slice(1), align: 'center',
  })),
];

const PermissionMark = ({ allowed }) => (allowed
  ? <CheckCircleRoundedIcon className='perm-yes' fontSize='small' titleAccess='Allowed' />
  : <RemoveRoundedIcon className='perm-no' fontSize='small' titleAccess='Not allowed' />);

export default function Roles({ rolePermissions, roleName }) {
  return (
    <SectionCard
      Icon={VerifiedUserOutlinedIcon}
      title='Role and permissions'
      subtitle={roleName
        ? `What the ${roleName} role can do in each part of BrickEZ.`
        : 'What your role can do in each part of BrickEZ.'}
      bodyless
    >
      <DataTable
        bare
        tableHead={columns}
        noDataText='No permissions are set for your role.'
        itemComponent={rolePermissions.map((element) => (
          <TableRow key={element.id}>
            <TableCell>{shortData(element.name || element.PermissionConfig?.name)}</TableCell>
            {ACTIONS.map((action) => (
              <TableCell key={action} align='center'>
                <PermissionMark allowed={element[action]} />
              </TableCell>
            ))}
          </TableRow>
        ))}
      />
    </SectionCard>
  );
}
